/* Build in libraries */

import { MapPinIcon } from '@heroicons/react/24/outline';

/* Third party libraries */
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import ApprovedApplicationsWidget from '@/components/Rover/Widgets/ApprovedApplicationsWidget';
import SocialDesignationWidget from '@/components/Rover/Widgets/SocialDesignationWidget';
import SummaryStatus from '@/components/Rover/Widgets/StatusSummaryWidget';
import TotalAmountApproved from '@/components/Rover/Widgets/TotalAmountApproved';
import TotalAmountRequested from '@/components/Rover/Widgets/TotalAmountRequested';
import TotalApplicationsWidget from '@/components/Rover/Widgets/TotalApplicationsWidget';
/* Components */
import Card from '@/components/UI/Card/index.tsx';
import LoadingCompanyDashboard from '@/components/UI/loading/LoadingCompanyDashboard';
import type { DashboardProjectByLocationInterface } from '@/components/Widgets/ProjectLocationWidget';
import { getClientApplicationsDashboard } from '../../../api/Rover/clientApplication';
/* Services */
import { RoverReactQueryKey } from '../../../constants/ReactQueryKeys';
import ClientApplicationsNav from './ClientApplicationsNav';

const ClientApplicationsDashboard = () => {
  //Tanstack: version 5 query implementation
  const fetchClientApplicationsDashboard = useQuery({
    queryKey: [RoverReactQueryKey.GET_CLIENT_APPLICATIONS_DASHBOARD],
    queryFn: () => getClientApplicationsDashboard(),
  });
  const dashboardData = fetchClientApplicationsDashboard?.data?.data;

  const [selectedProject, setSelectedProject] = useState<DashboardProjectByLocationInterface>();

  const _projectLocationHandler = (data: DashboardProjectByLocationInterface) => setSelectedProject(data);

  useEffect(() => {
    if (dashboardData?.project_location) {
      setSelectedProject(dashboardData?.project_location[0]);
    }
  }, [dashboardData?.project_location]);

  return (
    <>
      {fetchClientApplicationsDashboard.isLoading && <LoadingCompanyDashboard />}
      {!fetchClientApplicationsDashboard.isLoading && (
        <div className='container mx-auto flex flex-col gap-4'>
          <ClientApplicationsNav />
          <section className='grid md:grid-cols-2 md:grid-cols-2 xl:grid-cols-4 gap-4 lg:gap-8'>
            <TotalApplicationsWidget count={dashboardData?.total_applications || 0} />
            <ApprovedApplicationsWidget count={dashboardData?.total_approved || 0} />
            <TotalAmountRequested count={dashboardData?.total_amount_requested || '0'} />
            <TotalAmountApproved count={dashboardData?.total_amount_approved || '0'} />
          </section>
          {dashboardData?.application_status_summary && <SummaryStatus summary={dashboardData?.application_status_summary} />}
          <section>
            <Card title='Project Location'>
              {fetchClientApplicationsDashboard.isLoading && !selectedProject && (
                <div className='w-full flex justify-center items-center h-screen/2'>
                  <div className='flex justify-center items-center gap-2 text-primaryColor-normal'>
                    <MapPinIcon className='h-8 w-8' />
                    <h1>No Projects</h1>
                  </div>
                  <p>There are no assigned projects to display assigned to you as project lead.</p>
                </div>
              )}
              {/* {!fetchClientApplicationsDashboard.isLoading &&
                selectedProject && (
                  <div className='w-full grid grid-cols-6 h-screen/2'>
                    {dashboardData?.project_location && (
                      <div className='col-span-6 w-full border-l p-5'>
                        <CompGoogleMap
                          projectList={dashboardData?.project_location as any}
                          setLocation={projectLocationHandler}
                          link='/app/rover/client-applications/list'
                          queryKey='GET_GEO_CODE'
                          defaultZoom={20}
                        />
                      </div>
                    )}
                  </div>
                )} */}
            </Card>
          </section>
          <section className='grid md:grid-cols-1 xl:grid-cols-5 gap-4 lg:gap-8'>
            <div className='xl:col-span-3'>
              {dashboardData?.social_designation && <SocialDesignationWidget data={dashboardData?.social_designation} />}
            </div>
            {/* <div className='h-screen/2 col-span-2'>
              <ApplicationTimeline
                resourceType='ClientApplication'
                title='Recent Activities'
              />
            </div> */}
          </section>
        </div>
      )}
    </>
  );
};
export default ClientApplicationsDashboard;
